<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>attach_money</mat-icon>
        <div>Cobrança</div>
      </div>


    </mat-toolbar>
  </mat-card>

  <mat-card>
    <mat-tab-group>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon' style="color:green;">checklist</mat-icon>
          <div>Ativo</div>
        </ng-template>


        <div flex justify-content='flex-end' fxLayoutAlign="end">
          <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
            autocomplete="off">
            <!--
          <a mat-button (click)="capturePIX()" style='width:60px;'>
            <mat-icon color='primary'>currency_exchange</mat-icon>
          </a>
          -->
        </div>

        <!-- TABLE -->
        <mat-table [dataSource]="dataSource" matSort #activeSort="matSort" matSortActive="date" matSortDirection='desc'
          matSortDisableClear=true>

          <!-- Icon Column -->
          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style='font-size:1.2em; margin-top:10px;'>attach_money</mat-icon>
            </mat-cell>
          </ng-container>

          <!-- data Column -->
          <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.date | date: 'dd/MM/yyyy' }}
            </mat-cell>
          </ng-container>

          <!-- name Column -->
          <ng-container matColumnDef="member">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.member_name }} </mat-cell>
          </ng-container>

          <!-- status Column -->
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div *ngIf="element.status === '0'">
                Email enviado
              </div>
              <div *ngIf="element.status === '1'">
                Email lido
              </div>
              <div *ngIf="element.status === '2'">
                PIX gerado
              </div>
              <div *ngIf="element.status === '3'">
                PIX pago
              </div>
            </mat-cell>
          </ng-container>

          <!-- anuidade -->
          <ng-container matColumnDef="collect">
            <mat-header-cell *matHeaderCellDef> Anuidades </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <ul style="display: flex; flex-direction: column; padding: 0;">
                <li *ngFor="let item of element.collect">
                  <div> {{item.product_name}} - R$ {{item.price}},00</div>
                </li>
              </ul>
            </mat-cell>
          </ng-container>

          <!-- value -->
          <ng-container matColumnDef="value">
            <mat-header-cell *matHeaderCellDef> Total </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div>R$ {{element.value}},00</div>
            </mat-cell>
          </ng-container>

          <!-- link -->
          <ng-container matColumnDef="link">
            <mat-header-cell *matHeaderCellDef> Link </mat-header-cell>
            <mat-cell *matCellDef="let element" matTooltip="link enviado no emai" matTooltipPosition="after">
              <a target='_blank' [href]='element.link' *ngIf="element.link">
                <mat-icon>link</mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openArchiveDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-info' style='font-size:1.5em;'>
                  playlist_add
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>
          <!-- Header -->
          <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedColumns">
          </mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedColumns;">
          </mat-row>

        </mat-table>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon' style="color:gray;">checklist</mat-icon>
          <div>Arquivado</div>
        </ng-template>

        <div flex justify-content='flex-end' fxLayoutAlign="end">
          <input class='filter' matInput (keyup)="applyFilterHistory($event.target.value)" placeholder='filtro'
            autocomplete="off">
            <!--
          <a mat-button (click)="capturePIX()" style='width:60px;'>
            <mat-icon color='primary'>currency_exchange</mat-icon>
          </a>
          -->
        </div>

        <!-- TABLE -->
        <mat-table [dataSource]="dataSourceArchived" matSort matSort #historySort="matSort" matSortActive="date"
          matSortDirection='desc' matSortDisableClear=true>

          <!-- Icon Column -->
          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style='font-size:1.2em; margin-top:10px;'>attach_money</mat-icon>
            </mat-cell>
          </ng-container>

          <!-- data Column -->
          <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.date | date: 'dd/MM/yyyy' }}
            </mat-cell>
          </ng-container>

          <!-- name Column -->
          <ng-container matColumnDef="member">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.member_name }} </mat-cell>
          </ng-container>

          <!-- status Column -->
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div *ngIf="element.status === '0'">
                Email enviado
              </div>
              <div *ngIf="element.status === '1'">
                Email lido
              </div>
              <div *ngIf="element.status === '2'">
                PIX gerado
              </div>
              <div *ngIf="element.status === '3'">
                PIX pago
              </div>
            </mat-cell>
          </ng-container>

          <!-- anuidade -->
          <ng-container matColumnDef="collect">
            <mat-header-cell *matHeaderCellDef> Anuidades </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <ul style="display: flex; flex-direction: column; padding: 0;">
                <li *ngFor="let item of element.collect">
                  <div> {{item.product_name}} - R$ {{item.price}},00</div>
                </li>
              </ul>
            </mat-cell>
          </ng-container>

          <!-- value -->
          <ng-container matColumnDef="value">
            <mat-header-cell *matHeaderCellDef> Total </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div>R$ {{element.value}},00</div>
            </mat-cell>
          </ng-container>

          <!-- link -->
          <ng-container matColumnDef="link">
            <mat-header-cell *matHeaderCellDef> Link </mat-header-cell>
            <mat-cell *matCellDef="let element" matTooltip="link enviado no emai" matTooltipPosition="after">
              <a target='_blank' [href]='element.link' *ngIf="element.link">
                <mat-icon>link</mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openArchiveDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-info' style='font-size:1.5em;'>
                  playlist_add
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>
          <!-- Header -->
          <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedColumns">
          </mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedColumns;">
          </mat-row>

        </mat-table>

      </mat-tab>

    </mat-tab-group>


  </mat-card>

</div>